var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"xg-title",class:[_vm.styleName]},[_c('div',{staticClass:"cn"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"desc"},[_vm._v(_vm._s(_vm.text1))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17919ab4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/title.vue
// module id = null
// module chunks = 